import { useMemo } from 'react';
import { products } from '@/mocks/products';
import ProductCard from '@/components/feature/ProductCard';
import ScrollReveal from '@/components/base/ScrollReveal';
import type { Product } from '@/mocks/products';

interface YouMayAlsoLikeProps {
  currentProduct: Product;
}

export default function YouMayAlsoLike({ currentProduct }: YouMayAlsoLikeProps) {
  const related = useMemo(() => {
    const sameOccasion = products.filter(
      (p) => p.occasion === currentProduct.occasion && p.id !== currentProduct.id
    );
    const sameStyle = products.filter(
      (p) =>
        p.style === currentProduct.style &&
        p.id !== currentProduct.id &&
        !sameOccasion.find((o) => o.id === p.id)
    );
    const rest = products.filter(
      (p) =>
        p.id !== currentProduct.id &&
        !sameOccasion.find((o) => o.id === p.id) &&
        !sameStyle.find((s) => s.id === p.id)
    );
    return [...sameOccasion, ...sameStyle, ...rest].slice(0, 4);
  }, [currentProduct]);

  if (related.length === 0) return null;

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-500 text-center mb-2">
            You May Also Like
          </h2>
          <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-12 font-label">
            Pieces that pair perfectly
          </p>
        </ScrollReveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {related.map((product, idx) => (
            <ScrollReveal key={product.id} delay={idx * 100}>
              <ProductCard product={product} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}